<script lang="ts">
  import { navigate } from '../router.svelte';
  import { STAGE_ORDER, STAGE_META } from '@ui/stages';
  import type { CensusBlock, CensusSparkBlock } from '@api';
  import StatCard from './StatCard.svelte';

  // Engagement-momentum strip: one StatCard per LIVE stage (Rising / Steady / At
  // risk / Silent), showing the current count, the net change over the period, and a
  // sparkline of how the bucket has trended — the momentum-side mirror of the
  // contributor-role cards. Reads the same `census` / `census_spark` blocks as the
  // role strip, whose stage census is current-members-only; the terminal `departed`
  // stage is not part of the mix
  // here (see STAGE_ORDER), which is also what keeps these four filling one row.
  let { census, spark }: { census: CensusBlock; spark: CensusSparkBlock } = $props();

  const cards = $derived.by(() =>
    STAGE_ORDER.map((s) => {
      const sp = spark.stages[s] ?? [];
      const now = census.stages[s] ?? (sp.length ? (sp.at(-1) ?? 0) : 0);
      const d = now - (sp[0] ?? 0);
      return {
        stage: s,
        meta: STAGE_META[s],
        value: String(now),
        count: now,
        delta: sp.length >= 2 ? `${d >= 0 ? '+' : ''}${d}` : null,
        spark: sp,
      };
    }),
  );
  const total = $derived(cards.reduce((sum, c) => sum + c.count, 0));
</script>

<div class="flex items-baseline gap-2">
  <span class="eyebrow text-base-content/65">Engagement momentum</span>
  <span class="text-xs text-base-content/65">{total.toLocaleString()} members · trajectory over the last 14 days vs the 14 before</span>
</div>
<div class="mt-2 grid grid-cols-2 gap-3 sm:grid-cols-4">
  {#each cards as c (c.stage)}
    <StatCard
      label={c.meta.label}
      value={c.value}
      delta={c.delta}
      color={c.meta.color}
      info={c.meta.blurb}
      spark={c.spark}
      sparkLabels={spark.labels}
      sparkFormat={(v) => `${v} members`}
    >
      {#snippet action()}
        <button
          class="inline-flex items-center gap-0.5 text-[0.7rem] font-medium text-base-content/65 transition-colors hover:text-primary"
          onclick={() => navigate(`/admin/community/members?stage=${c.stage}`)}
        >See {c.meta.label.toLowerCase()} <span aria-hidden="true">→</span></button>
      {/snippet}
    </StatCard>
  {/each}
</div>
